/* eslint-disable */

export function getYoutubeVideoId(urlOrVideoId) {
  /**
   * TAKEN FROM OUR DESIGNER'S HELPERS.JS MIXIN -- IF WE GO WITH THIS, WE WOULD HAVE TO TEST:
   * 
   * dashboard/MediaLibrary.vue
   * dashboard/PremadeBulbs.vue
   * 
   * since that is the only reference to the package/utilities/helpers/getYoutubeVideoId.js exported function
   */
   if (
    urlOrVideoId.length === 11
    && !urlOrVideoId.includes('youtube.com')
    && !urlOrVideoId.includes('.be')
  ) return urlOrVideoId;
  const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|live\/)([^#\&\?]*).*/;
  const match = urlOrVideoId.match(regExp);
  if (match && match[1].length === 11) return match[1];
  throw new Error ('The sole argument for getYoutubeVideoID() must be a YouTube URL or a YouTube video ID. Provided value: ' + urlOrVideoId);
}
